import styled from '@emotion/styled';
import { Colors } from 'styles/variables/colors';

const { blue } = Colors;
export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
`;

export const FlagsWrapper = styled.div`
    display: flex;
    gap: 8px;
`;

export const FlagContainer = styled.div`
    position: relative;
    width: 40px;
    height: 30px;
    border-radius: 8px;
    overflow: visible;
    box-sizing: border-box;
    &:hover {
        border: 1px solid ${blue};
        cursor: pointer;
    }
`;

export const Notification = styled.div`
    position: absolute;
    top: -8px;
    right: -8px;
    background: #fff;
    color: #000;
    font-size: 10px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
`;

export const FlagImage = styled.img`
    border-radius: 7px;
`;

export const Title = styled.h3`
    text-align: center;
    margin: 0px 14px 14px 14px;
`;

export const Wrapper = styled.div`
    padding: 14px 8px 8px 8px;
    height: 70vh;
    overflow-y: auto;
`;
